import React from "react"
import PropTypes from "prop-types"

const SettingsToggle = ({ checked, onChange, label, disabled = false }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    className={`admin-settings__toggle${
      checked ? " admin-settings__toggle--on" : ""
    }`}
    onClick={() => onChange(!checked)}
  >
    <span className="admin-settings__toggle-knob" aria-hidden="true" />
  </button>
)

SettingsToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}

export default SettingsToggle
